"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineObject9 = void 0;
const iinventory_search_entity_1 = require("./iinventory-search-entity");
function parseInlineObject9(data) {
    if (data.stock_movements_filter !== null && typeof data.stock_movements_filter === 'object')
        data.stock_movements_filter = (0, iinventory_search_entity_1.parseIInventorySearchEntity)(data.stock_movements_filter);
    return data;
}
exports.parseInlineObject9 = parseInlineObject9;
